import styled from 'styled-components';
import colors from 'constants/colors';

export const Container = styled.div`
    width: 250px;
    min-height: 53px;
    padding: 16px;
    border: 1px solid ${colors.dimGrey};
    background-color: ${colors.black2};

    .tooltip-text {
      color: ${colors.white};
      font-size: 14px;
      font-weight: 400;
    }
`;
